export default {
  loading: {
    message: 'Chargement',
    overlay: false,
  },
  login: {
    message: null,
    loggedIn: false,
  },
  maitrises: {
    data: [],
    allData: [],
    actif: true,
    filteredMaitrises: [],
    treeSelectMaitrises: [],
    filters: {
      idMaitrises: [],
    },
  },
  arrondissements: {
    data: [],
    currentVilleData: [],
  },
  secteurs: {
    data: [],
    actif: true,
  },
  materiel: {
    data: [],
    actif: true,
  },
  tournee: {
    data: [],
    actif: true,
  },
  collectes: {
    data: [],
    filtredCollectes: [],
    filters: {
      typeList: [],
      idSecteurs: [],
      idNumeros: [],
      idAdresses: [],
    },
    availableSecteurs: null,
    availablesTypes: null,
    availablesNumeros: null,
    availablesAdresses: null,
    actif: true,
  },
  demandes: {
    data: [],
    filtredDemandes: [],
    filters: {
      daysList: [],
      idCantonniers: [],
      selectedStatus: '1'
    },
    status: [
      'Annulée',
      'En attente de réponse',
      'Réalisée',
      'Non réalisée',
      'Acceptée',
      'Refusée'
    ],
    availableDates: null,
    initialDates: null,
    availablesCantonniers: null,
    initialCantonniers: null,
    actif: true,
    cancellationError: ''
  },
  demandesEnCours: {
    data: [],
  },
  implentationMaterielGeopassages: {
    data: [],
    message: null,
    filters: {
      idMateriel: '',
      idArrond: '',
      idSecteur: '',
      infoWindows: true,
    },
    actif: true,
  },
  realtime: {
    filters: {
      toggleFilterTourneeInProgress: true,
    },
    actif: true,
  },
  reportingFilter: {
    materiels: [],
    dates: [],
    agents: [],
  },
  reporting: {
    materiels: [],
    cantonniers: [],
    secteurs: [],
    filters: {
      idsMateriel: [],
      daysList: [],
      idAgent: [],
    },
    availableDates: null,
    availableMateriel: null,
    availableAgents: null,
    allGeopassages: null,
    actif: true,
  },
  credentialsId: null,
  currentMaitriseArrondissement: null,
  maitrise: null,
  priorites: [{name: 'Très Urgente', id: 1}, {name: 'Urgente', id: 2}, {name: 'Peu urgente', id: 3},],
  allUsers: {
    data: [],
    filteredMaitrises: [],
    treeSelectMaitrises: [],
    filters: {
      idUsers: [],
    },
  },
  villes: {
    data: [],
    availableVilles: [],
    envoi_sms_to_multiple_contacts: false,
    filters: {
      idsVille: [],
      modulesList: [],
    },
    availableModulesPerVille: null,
  },
  collectivityRestrictions: null,
//////////////////////////////////////////////////////////////////////////////////

  //
  // MODULES
  //

  adminUsers: {
    data: [],
    filteredAdminUsers: [],
    treeSelectAdminUsers: [],
    filters: {
      idUsers: [],
    },
  },
  allArrondissements: {
    data: []
  },
  currentVille: {
    id: null,
    name: null,
    coords: {
      lat: null,
      lon: null
    },
    arrondissements: [],
    materiels: [],
    materielsPermis: [],
    cantonniers: [],
    secteurs: [],
    tournees: [],
    moduleBackoffice: [],
    module_android: [],
  },
  currentUser: {
    role: '',
    id: '',
    arrondissement_id: '',
    arrondissementName: ''
  },
  materiels: {
    allData: [],
    data: [],
    dataRemontees: [],
    dataTournees: [],
    actif: true,
  },
  cantonniers: {
    data: [],
    allData: [],
    actif: true,
  },

  map: {
    filters: {
      idTournee: '',
      idMateriel: '',
      idAnomalie: '',
      idSac: '',
      idEvenement: '',
      mode: 'materiel',
      infoWindows: true,
      filterPhoto: false,
      date: new Date(),
    },
    searching: false,
    result: {
      dataTournees: [],
      tournees: [],
      remontees: [],
      declarations: [],
      infoDeclarations: []
    },
    infoTournee: {
      idMateriel: '',
      nomMateriel: '',
      cantonnier: '',
      duree: ''
    },
    message: null,
    mode: 'tournees',
    realTimeMode: true,
    realTimeTournees: [],
    markers: [],
    actif: true,
  },
  implentationContenants: {
    data: [],
    fitredData: [],
    message: null,
    filters: {
      idType: '',
      idSecteur: '',
      infoWindows: true,

    },
    availableSecteurs: null,
    availablesTypes: null,
    availablesNumeros: null,
    availablesAdresses: null,
    actif: true,
  },
  contenants: {
    allData: [],
    data: [],
    filtredContenants: [],
    filters: {
      typeList: [],
      idSecteurs: [],
      idNumeros: [],
      idAdresses: [],
    },
    availableSecteurs: null,
    availablesTypes: null,
    availablesNumeros: null,
    availablesAdresses: null,
    actif: true,
  },
  statistiques: {
    dataTournees: [],
    dataDemandes: [],
    dataSignalements: []
  },
  tournees: {
    data: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js